import React, { useContext, useState } from "react";
//axios and base url
import axios from "axios";

import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { ToastError } from "../../../../../functions/ToastShow";

const offlineTables = [
  { id: 1, name: "Has Logo", value: "has_logo" },
  { id: 2, name: "Has Item Barcode", value: "has_item_barcode" },
  { id: 3, name: "Has Fbr", value: "has_fbr" },
  { id: 4, name: "Has Srb", value: "has_srb" },
  { id: 5, name: "Has Pra", value: "has_pra" },
  { id: 6, name: "Has Kpra", value: "has_kpra" },
  { id: 7, name: "Has Feedback Qr", value: "has_feedback_qr" },
  { id: 8, name: "Has Local Invoice", value: "has_local_invoice" },
  { id: 9, name: "Has Paid Print", value: "has_paid_print" },
  { id: 10, name: "Has Unpaid Print", value: "has_unpaid_print" },
  { id: 11, name: "Foods inn", value: "has_foodsinn_kot" },
  { id: 12, name: "Self Order", value: "has_self_order" },
];

const initialState = {
  has_logo: true,
  has_item_barcode: false,
  has_fbr: false,
  has_srb: false,
  has_pra: false,
  has_kpra: false,
  has_feedback_qr: false,
  has_local_invoice: false,
  has_paid_print: false,
  has_unpaid_print: true,
  has_foodsinn_kot: false,
  has_self_order: false,
  printer_ip: ""
};

const GenerateTestController = () => {
  const { t } = useTranslation();
  let { loading, setLoading } = useContext(SettingsContext);
  
  const [offlineSync, setOfflineSync] = useState(initialState);

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;

    if (type === "text") {
      setOfflineSync({ ...offlineSync, [name]: value });
      return;
    }

    if (!checked && (name === "has_unpaid_print" || name === "has_paid_print")) {
      ToastError({ title: t("Mandatory to select one from Has Paid Print or Has Unpaid Print") });
      return;
    }

    let updatedState = { ...offlineSync, [name]: checked };

    if (name === "has_unpaid_print" && checked) {
      updatedState.has_paid_print = false;
    } else if (name === "has_paid_print" && checked) {
      updatedState.has_unpaid_print = false;
    }

    setOfflineSync(updatedState);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const url = BASE_URL + "/settings/generate-test-controller";
    setLoading(true);
    
    axios.post(url, offlineSync, {
      headers: { Authorization: `Bearer ${getCookie()}` },
      responseType: 'blob', // Important for downloading file
    })
    .then((res) => {
      if (res) {
        toast.success(
          <span style={{ whiteSpace: "pre-line" }}>{t("Generated Successfully")}</span>,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        
        // Create a blob from the response and download it
        const blob = new Blob([res.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'TestController.php'); // or any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      ToastError({ title: t("Please try again") });
    });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Generate Test Controller"))}</title>
      </Helmet>
      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${loading && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    <div className="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-12 t-mb-15 mb-md-0 ">
                          <ul className="t-list mb-3 fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Generate Test Controller"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        
                        {/* Form starts here */}
                        <form
                          className="row card p-4 mx-3 sm-text my-3 shadow-sm border-0"
                          style={{ width: "97%", backgroundColor: "#fdfdfd", borderRadius: "10px" }}
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="row">
                            {
                              offlineTables && offlineTables.map((item) => {
                                return (
                                  <div className="col-md-6 col-lg-3 mb-3" key={item.id}>
                                    <div 
                                      className={`p-3 border rounded d-flex align-items-center pointer-cursor ${offlineSync[item.value] ? 'border-primary' : 'border-light'}`}
                                      onClick={() => {
                                        handleChange({ target: { name: item.value, checked: !offlineSync[item.value] } })
                                      }}
                                      style={{ 
                                        transition: 'all 0.2s ease-in-out', 
                                        minHeight: '65px',
                                        backgroundColor: offlineSync[item.value] ? '#f0f8ff' : '#f8f9fa',
                                        boxShadow: offlineSync[item.value] ? '0 4px 6px rgba(0,123,255,0.1)' : 'none'
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input pointer-cursor m-0"
                                        id={item.name}
                                        name={item.value}
                                        value={item.value}
                                        onChange={(e) => handleChange(e)}
                                        checked={offlineSync[item.value] === true}
                                        style={{ transform: "scale(1.3)" }}
                                        onClick={(e) => e.stopPropagation()}
                                      />
                                      <label htmlFor={item.name} className="control-label ml-3 mb-0 font-weight-bold pointer-cursor" style={{ userSelect: "none", fontSize: "14px", color: offlineSync[item.value] ? '#0056b3' : '#495057' }} onClick={(e) => e.preventDefault()}>
                                        {_t(t(item.name))}
                                      </label>
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-6 col-lg-3">
                              <div className="form-group">
                                <label className="font-weight-bold" style={{ fontSize: "14px", color: "#495057" }}>
                                  {_t(t("Printer IP"))}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="printer_ip"
                                  value={offlineSync.printer_ip}
                                  onChange={handleChange}
                                  maxLength="8"
                                  minLength="3"
                                  required
                                  placeholder={_t(t("e.g 192.168 or cash"))}
                                  style={{ borderRadius: "8px", border: "1px solid #ced4da", padding: "10px 15px" }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="form-group mt-4 pt-3 border-top">
                            <div className="text-right">
                              <button
                                disabled={loading}
                                className="btn btn-primary px-5 py-2 font-weight-bold shadow-sm"
                                type="submit"
                                style={{ borderRadius: "8px", fontSize: "15px" }}
                              >
                                <i className="fa fa-cogs mr-2"></i>
                                {_t(t("Generate"))}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default GenerateTestController;
